import * as yup from "yup";
import SurveyQuestionnaireValidationSchema from "./SurveyQuestionnaireValidationSchema";

const SurveyValidationSchema = yup.object().shape({
  title: yup.string().required("Name is required."),
  tags: yup.array().of(yup.string()).required("Tags is required"),
  questions: SurveyQuestionnaireValidationSchema,
  status: yup.string().required("Status is required."),
  scheduledStartDate: yup
    .date()
    .required("Schedule send date/time is required."),
  scheduledEndDate: yup.date().required("Schedule end date/time is required."),
});

export default SurveyValidationSchema;
